export default "__VITE_ASSET__BpuzbPCH__"